import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import {injectIntl} from "gatsby-plugin-react-intl";
import ChannelsData from "../../content/home/channels.json";
import IconCard from "../misc/icon-card";
import CalloutCard from "../misc/callout-card";

class FeaturesChannels extends React.Component {

    render = () => {
        return (

            <div className={`features-channels`}>
                <Container>
                    <div className={`title`}>{ChannelsData[this.props.intl.locale].title}</div>
                    <Row>
                        {ChannelsData[this.props.intl.locale].channels.map((channel, i) => {
                            return (
                                <Col key={i} lg={4}>
                                    <IconCard content={channel} />
                                </Col>
                            )
                        })}
                        <Col lg={4}>
                            <CalloutCard theme={`secondary`} content={ChannelsData[this.props.intl.locale].explore} />
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default injectIntl(FeaturesChannels)
